import React from 'react'
import EasingTick from './shapes/easing-tick'
import { PADDING } from './constants'

class SmallLabelXAxis extends React.PureComponent {
  static defaultProps = {
    className: 'chart-show-small',
    label: '',
    x: 0,
    y: 0,
    padding: PADDING * 1.5,
    stroke: 'black',
    width: 0
  }

  render() {
    const { className, x, y, width, stroke, label, padding } = this.props

    return (
      <g className={className} fontSize="12">
        <line x1={x} x2={width} y1={y} y2={y} stroke={stroke} strokeWidth="2" />
        <EasingTick
          label={label.toUpperCase()}
          x={x}
          y={y + padding}
          width={width - x}
        />
      </g>
    )
  }
}

export default SmallLabelXAxis



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/small-label-x-axis.js